import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { finalize, map, takeUntil } from 'rxjs/operators';

import { VatDictionaryService } from 'projects/workspace/src/app/accounting/accounting-settings-module/services';
import { CountryModel } from '../../../rnpl-common';
import { selectCountries } from 'projects/workspace/src/app/store/selectors/shared.selectors';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { VatDictionaryItemModel } from '../../../../../../projects/workspace/src/app/accounting/accounting-settings-module/models';


@Component({
  selector: 'rnpl-add-vat-rate-modal',
  templateUrl: './add-vat-rate-modal.component.html',
  styleUrls: ['./add-vat-rate-modal.component.scss']
})
export class AddVatRateModalComponent implements OnDestroy {

  public countryControl: FormControl = new FormControl();
  public rateControl: FormControl = new FormControl(null, [Validators.required]);

  readonly destroy$: Subject<void> = new Subject();
  public countries$: Observable<CountryModel[]> = this.store.select(selectCountries)
    .pipe(map((countries: CountryModel[]) => {
      return countries
        .filter((c: CountryModel) => {
          return c.code_iso3.toLowerCase() === this.data.countryIso3.toLowerCase()
            || (this.data.iso3ForVat && c.code_iso3.toLowerCase() === this.data.iso3ForVat.toLowerCase());
        });
    }));
  readonly submitRequest$: BehaviorSubject<boolean> = new BehaviorSubject(null);

  constructor(
    private readonly store: Store<AppState>,
    public vatDictionaryService: VatDictionaryService,
    public dialogRef: MatDialogRef<AddVatRateModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      countryIso3: string,
      iso3ForVat: string,
    }
  ) {
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        this.dialogRef.close();
      }
    });

    if (this.data.countryIso3 && this.data.iso3ForVat) {
      this.countryControl.patchValue(this.data.countryIso3);
    }
  }

  public submit(): void {
    this.rateControl.markAllAsTouched();
    this.rateControl.updateValueAndValidity();
    if (this.rateControl.invalid || this.submitRequest$.getValue()) { return; }

    this.submitRequest$.next(true);

    this.vatDictionaryService.addVatDictionaryItm(this.countryControl.value || this.data.countryIso3, this.rateControl.value)
      .pipe(
        finalize(() => this.submitRequest$.next(false)),
        takeUntil(this.destroy$),
      ).subscribe((item: VatDictionaryItemModel) => this.dialogRef.close(item));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
